<header class='{{getHeaderStyle()}}' fxHide='true' fxShow.gt-md='true'>
    <mat-toolbar fxLayout='row' fxLayoutAlign='start center' fxLayoutAlign.xs='space-between start'>
        <span fxLayout='column' fxLayoutAling='center center'>
            <img src="./assets/images/logo-black-2.png" height='50px' />
        </span>

        <span fxLayout='row' fxLayoutAlign='center center' fxShow='false' fxShow.gt-sm class='pads' fxFlex='1 1 100%'>
            <button mat-button class='s18-raised-button' (click)='goTo("dashboard")'>
                {{ _homeName }}
            </button>
            <button mat-button class='s18-raised-button' *ngIf='!isLoggedIn()' (click)='goTo("products")'>
                PRODUCTS
            </button>
            <button mat-button class='s18-raised-button' *ngIf='!isLoggedIn()' (click)='goTo("pricing")'>
                PRICING
            </button>
            <button mat-button class='s18-raised-button' (click)='goTo("how-to")'>
                SUPPORT
            </button>
            <button mat-button class='s18-raised-button' (click)='goTo("player-lookup")'>
                PLAYER LOOKUP
            </button>
        </span>
        <span fxShow='false' fxShow.gt-sm style='color: black; padding-right:100px' class='pads'>
            <a href='https://www.facebook.com/golfgameskeeper'>
                <i class="fa fa-facebook" aria-hidden="true"></i>
            </a>
            <a href='https://www.instagram.com/golfgameskeeper/'>
                <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
        </span>
        <span class='pads' fxLayout='row' fxLayout.xs='column' style='padding-right:10px' *ngIf='!isLoggedIn()'>
            <button mat-raised-button (click)='openDialog()' class='s18-raised-button s18-header-action-button'>
                <mat-icon>person</mat-icon>
                MEMBER AREA
            </button>
            <button mat-raised-button (click)='showRegisterDialog()' class='s18-raised-button s18-header-action-button'>
                JOIN NOW
            </button>
        </span>
        <span fxShow='false' fxShow.gt-sm class='pads' style='padding-right:10px' *ngIf='isLoggedIn()'>
            <button mat-button [matMenuTriggerFor]="profileMenu" class='s18-raised-button'>
                <mat-icon>person</mat-icon>
                {{_player.first}}
            </button>
        </span>
    </mat-toolbar>
</header>
<header class='fixed-mobile' fxHide='true' fxShow.lt-lg='true'>
    <mat-toolbar fxLayout='row' fxLayoutAlign='space-between center' fxLayoutAlign.xs='space-between center'>
        <div fxLayout='column' fxLayoutAling='center center'>
            <img src="./assets/images/logo-black-2.png" height='50px' />
        </div>
        <div [matMenuTriggerFor]="mobile">
            <mat-icon>menu</mat-icon>
        </div>
    </mat-toolbar>
</header>

<mat-menu #profileMenu='matMenu' [overlapTrigger]="false">
    <a (click)="goTo('/profile')">
        <button mat-menu-item>
            <mat-icon> person </mat-icon>
            <span> Profile </span>
        </button>
    </a>
    <a (click)="goTo('/notifications')">
        <button mat-menu-item>
            <mat-icon> notifications </mat-icon>
            <span> Notifications </span>
        </button>
    </a>
    <button mat-menu-item (click)='logout()'>
        <i class="fa fa-sign-out" aria-hidden="true"></i>
        Logout
    </button>
</mat-menu>

<mat-menu x-position='before' #mobile='matMenu'>
    <button mat-menu-item class='s18-raised-button' (click)='goTo("dashboard")'>
        <mat-icon>home</mat-icon>
        {{ _homeName }}
    </button>
    <button mat-menu-item class='s18-raised-button' *ngIf='!isLoggedIn()' (click)='goTo("products")'>
        <mat-icon>list</mat-icon>
        Products
    </button>
    <button mat-menu-item class='s18-raised-button' *ngIf='!isLoggedIn()' (click)='goTo("pricing")'>
        <mat-icon>attach_money</mat-icon>
        Pricing
    </button>
    <button mat-menu-item class='s18-raised-button' (click)='goTo("how-to")'>
        <mat-icon>perm_phone_msg</mat-icon>
        Support
    </button>

    <hr width='90%' />
    <span class='pads' fxLayout='row' fxLayout.xs='column' style='padding-right:10px' *ngIf='!isLoggedIn()'>
        <button mat-menu-item (click)='openDialog()' class='s18-raised-button s18-header-action-button'>
            <mat-icon>person</mat-icon>
            MEMBER AREA
        </button>
        <button mat-menu-item (click)='showRegisterDialog()' class='s18-raised-button s18-header-action-button'>
            JOIN NOW
        </button>
    </span>
    <span fxShow='false' fxShow.gt-sm class='pads' style='padding-right:10px' *ngIf='isLoggedIn()'>
        <button mat-button [matMenuTriggerFor]="profileMenu" class='s18-raised-button'>
            <mat-icon>person</mat-icon>
            {{_player.first}}
        </button>
    </span>
    <button mat-menu-item *ngIf='isLoggedIn()' [matMenuTriggerFor]="profileMenu" class='s18-raised-button'>
        <mat-icon>golf_course</mat-icon>
        {{_player.first}}
    </button>
</mat-menu>